export default "__VITE_ASSET__3CvqeXMu__"